import React from 'react';
import HomeFiveMain from './HomeFiveMain';
import HeaderFive from '../../components/Header/HeaderFive';
import FooterThree from '../../components/Footer/FooterThree';

const HomeFive = () => {
  return (
    <>
      <HeaderFive />

      <HomeFiveMain />

      <FooterThree />
    </>
  );
};

export default HomeFive;
